export default "__VITE_ASSET__Bp_oBF$r__"